if (!customElements.get('mbe-cart-offers')) {
  customElements.define('mbe-cart-offers', class extends HTMLElement {
    connectedCallback() {
      this.onClick = event => {
        const button = event.target.closest('[data-mbe-offer]');
        if (button && this.contains(button)) this.choose(button);
      };
      this.addEventListener('click', this.onClick);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
    }
    disconnectedCallback() { this.removeEventListener('click', this.onClick); this.unsubscribe?.(); this.renderController?.abort(); }
    async refresh() {
      if (this.busy) return;
      this.renderController?.abort();
      this.renderController = new AbortController();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart?section_id=' + encodeURIComponent(this.dataset.sectionId), {signal:this.renderController.signal});
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.getElementById('shopify-section-' + this.dataset.sectionId);
        const current = this.closest('[id^="shopify-section-"]');
        if (next && current && this.isConnected) current.replaceWith(next);
      } catch (error) { if (error.name !== 'AbortError') this.querySelector('[role="status"]').textContent = this.dataset.changed; }
    }
    async choose(button) {
      if (this.busy) return;
      this.busy = true;
      this.renderController?.abort();
      const controls = [...this.querySelectorAll('button, select'), ...document.querySelectorAll('[name="checkout"]')];
      const disabled = controls.map(control => control.disabled);
      controls.forEach(control => {control.disabled = true;});
      const status = this.querySelector('[role="status"]');
      status.textContent = this.dataset.loading;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(root + 'cart.js', {cache:'no-store'});
        if (!cartResponse.ok) throw new Error('cart');
        const cart = await cartResponse.json();
        const select = button.closest('article')?.querySelector('[data-mbe-addon-variant]');
        const targetId = Number(select?.value || button.dataset.targetId);
        if (button.hasAttribute('data-service-addon')) {
          const eligibleHandles = (button.dataset.eligibleHandles || 'mix,mix-master').split(',');
          if (!cart.items.some(item => eligibleHandles.includes(item.handle))) throw new Error('changed');
          if (cart.items.some(item => item.product_id === Number(button.dataset.targetProduct))) {window.location.assign(root + 'cart'); return;}
        }
        const targets = cart.items.filter(item => item.variant_id === targetId);
        let endpoint, payload;
        if (button.dataset.kind === 'add') {
          if (targets.length) { window.location.assign(root + 'cart'); return; }
          endpoint = 'cart/add.js'; payload = {items:[{id:targetId,quantity:1}]};
        } else {
          const source = cart.items.find(item => item.key === button.dataset.sourceKey);
          if (!source || source.variant_id !== Number(button.dataset.sourceId) || source.quantity !== Number(button.dataset.expectedQuantity) || Object.keys(source.properties || {}).length || source.selling_plan_allocation || targets.length > 1 || targets.some(item => Object.keys(item.properties || {}).length || item.selling_plan_allocation)) throw new Error('changed');
          if (button.dataset.kind === 'bundle') {
            const excluded = button.dataset.excluded.split(',');
            if (source.quantity !== 1 || targets.length || cart.items.some(item => item.key !== source.key && excluded.includes(item.handle))) throw new Error('changed');
          }
          const updates = {[source.key]:0};
          const targetKey = targets[0]?.key || String(targetId);
          updates[targetKey] = (targets[0]?.quantity || 0) + source.quantity;
          endpoint = 'cart/update.js'; payload = {updates};
        }
        const note = document.querySelector('[name="note"]');
        if (endpoint === 'cart/update.js' && note) payload.note = note.value;
        if (endpoint === 'cart/add.js' && note && note.value !== (cart.note || '')) {
          const noteResponse = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({note:note.value})});
          if (!noteResponse.ok) throw new Error('update');
        }
        const response = await fetch(root + endpoint, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('update');
        window.location.assign(root + 'cart');
      } catch (error) {
        status.textContent = error.message === 'changed' ? this.dataset.changed : this.dataset.error;
        controls.forEach((control,index) => {control.disabled = disabled[index];});
        this.busy = false;
      }
    }
  });
}
if (!customElements.get('mbe-product-pairs')) {
  customElements.define('mbe-product-pairs', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      const variants = JSON.parse(this.dataset.variants || '[]').map(String);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (event.source === 'product-form' && variants.includes(String(event.productVariantId))) window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      });
    }
    disconnectedCallback() {this.unsubscribe?.();}
  });
}
